(() => {
  const root = document.querySelector('[data-emb-faq]');
  const input = root?.querySelector('[data-emb-faq-search]');
  const items = root ? [...root.querySelectorAll('[data-emb-faq-item]')] : [];
  const status = root?.querySelector('[data-emb-faq-results]');
  if (!root || !input || !items.length) return;

  const filter = () => {
    const query = input.value.trim().toLocaleLowerCase();
    let visible = 0;
    items.forEach((item) => {
      const matches = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });
    status.textContent = query ? `${visible} ${visible === 1 ? 'answer' : 'answers'} found.` : 'Showing all questions.';
  };
  input.addEventListener('input', filter);
})();
